import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
// componentes
import PieChart from "./pieChart";
import Totalizers from "./totalizers";
//service
import {
  getMatch,
  getMatchNoRoom,
  getConfigMatch,
} from "../../../../utils/services/match";

export default function DashboardMatch(props) {
  const { isOpen, toggle, eventId } = props;
  // contador
  const [countUserRoom, setCountUserRoom] = useState(0);
  const [countUserNoRoom, setCountUserNoRoom] = useState(0);
  // todos usuarios
  const [users, setUsers] = useState([]);
  // usuarios da tabela de listagem do match
  const [usersTable, setUsersTable] = useState([]);

  async function getAllMatchFunc(groupsBlock) {
    var allUsers = [];

    await getMatch({
      eventId: eventId,
      jwt: "",
      offset: 1,
      limit: 10000,
      search: "",
    }).then((res) => {
      if (res?.count) {
        var totalUsers = [];

        res.data.map((data) => {
          if (data.login_email_1) {
            totalUsers.push({
              loginName: data.login_nome_1,
              group: data.grupos_id_1 ? data.grupos_id_1 : [],
              status: data.login_status_1,
              roomSize: data.room_size,
            });
          }

          if (data.login_email_2) {
            totalUsers.push({
              loginName: data.login_nome_2,
              group: data.grupos_id_2 ? data.grupos_id_2 : [],
              status: data.login_status_2,
              roomSize: data.room_size,
            });
          }

          if (data.login_email_3) {
            totalUsers.push({
              loginName: data.login_nome_3,
              group: data.grupos_id_3 ? data.grupos_id_3 : [],
              status: data.login_status_3,
              roomSize: data.room_size,
            });
          }

          if (data.login_email_4) {
            totalUsers.push({
              loginName: data.login_nome_4,
              group: data.grupos_id_4 ? data.grupos_id_4 : [],
              status: data.login_status_4,
              roomSize: data.room_size,
            });
          }
        });

        var filterGroupsBlocks = totalUsers.filter(
          (data) =>
            !data.group.some((filter) => groupsBlock.includes(filter.id))
        );

        allUsers.push(...filterGroupsBlocks);

        setUsersTable(totalUsers);

        setCountUserRoom(filterGroupsBlocks.length);
      }
    });

    await getMatchNoRoom({
      eventId: eventId,
      limit: 10000,
      offset: 1,
      jwt: "",
    }).then((res) => {
      if (res?.count) {
        const totalUsers = res.data.map((e) => {
          return {
            loginId: e.login_id,
            group: e?.grupos[0] ? e.grupos : [],
            status: "noRoom",
          };
        });

        var filterGroupsBlocks = totalUsers.filter(
          (data) =>
            !data.group.some((filter) => groupsBlock.includes(filter.id))
        );

        allUsers.push(...filterGroupsBlocks);

        setCountUserNoRoom(filterGroupsBlocks.length);
      }
    });

    setUsers(allUsers);
  }

  async function getConfigMatchFunc() {
    var groupsBlock = [];

    await getConfigMatch({
      token: "",
      eventId: eventId,
    }).then((res) => {
      if (res.message === "matchByEvent" && res.data[0]?.noMatchGroups) {
        groupsBlock = res.data[0]?.noMatchGroups;
      }
      getAllMatchFunc(groupsBlock);
    });
  }

  useEffect(() => {
    getConfigMatchFunc();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader toggle={toggle}>Dashboard</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <PieChart
                data={{
                  userRoom: countUserRoom,
                  userNoRoom: countUserNoRoom,
                }}
              />
            </Col>

            <Col md={6}>
              <Totalizers users={users} usersTable={usersTable} />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
